<template>
  <hic-list-page title="租户管理" :entities="entities" :condition="condition" @load="page" :loading="searchLoading" keyword-placeholder="请输入名称或编码" hide-footer>
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small" v-if="permission.masterdata_tenant_create"> <i class="el-icon-plus"></i> 入院通知单 </el-button>
    </template>

    <el-table-column v-if="permission.masterdata_tenant_edit || permission.masterdata_tenant_delete" label="操作" fixed="left" width="60" align="center">
      <template slot-scope="scope">
        <el-button v-if="permission.masterdata_tenant_edit && scope.row.id" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" title="编辑" />
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" fixed="left">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="ID" prop="id" width="50" align="right" />
    <el-table-column label="编码" prop="code" width="100" align="center"></el-table-column>
    <el-table-column label="信用代码" prop="creditCode" align="center"></el-table-column>
    <el-table-column label="地址" prop="address" show-overflow-tooltip></el-table-column>
    <el-table-column label="序号" prop="seqNo" align="center"></el-table-column>
    <el-table-column label="电话" prop="phone" width="150" align="right"></el-table-column>
    <el-table-column label="停用" prop="disabled" width="60" align="center">
      <template slot-scope="scope">
        <el-tag v-if="scope.row.disabled" type="danger" size="mini" effect="plain">是</el-tag>
        <el-tag v-else type="success" size="mini" effect="plain">否</el-tag>
      </template>
    </el-table-column>
    <edit :visible.sync="showEditor" v-model="entity" @saved="saved" />
  </hic-list-page>
</template>
<script>
  import api from "./api";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  // import cfg from "@/common/cfg"
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_tenant_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    components: {
      edit: () => import("./edit"),
    },
    data() {
      return {
        searchLoading: false,
        showEditor: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          sort: "id",
          asc: false,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        editIndex: null,
      };
    },
    computed: {
      ...mapGetters(["dict", "permission"]),
    },
    created: function () {
      this.$store.dispatch("loadDicts", ["TenantType", "HospitalGrade"]);
    },
    methods: {
      page: function (pageIndexOnView) {
        let _this = this;
        this.searchLoading = true;
        api.Tenant.query(this.condition).then((res) => {
          _this.entities = res;
          _this.searchLoading = false;
        });
      },
      create: function () {
        this.editIndex = null;
        this.entity = { id: null };
        this.showEditor = true;
        if (this.$refs.editor) {
          this.$refs.editor.resetFields();
        }
      },
      edit(row, index) {
        this.editIndex = index;
        this.entity = JSON.parse(JSON.stringify(row));
        this.showEditor = true;
        if (this.$refs.editor) {
          this.$refs.editor.clearValidate();
        }
      },
      saved(newEntity) {
        if (this.editIndex != null) {
          this.entities.items.splice(this.editIndex, 1, newEntity);
          this.editIndex = null;
        } else {
          this.entities.items.unshift(newEntity);
        }
      },
    },
  };
</script>
<style scoped></style>
